export function useQueryProp() {
  function propStateInQuery(url: string = '/') {
    const route = useRoute()

    const _url = new URL(url, `${location.protocol}//${location.host}`)

    const searchParams = new URLSearchParams()

    for (const key in route.query) {
      searchParams.append(key, String(route.query[key]))
    }

    _url.search = searchParams.toString()

    console.log(url, '->', _url.toString())

    return _url.toString().replace(`${location.protocol}//${location.host}`, '')
  }

  return { propStateInQuery }
}
